export default __webpack_public_path__ + "static/media/detail_main_img_2_1.8d462217.png";